import React, { useState, useCallback, useEffect, useRef } from 'react';
// import GoogleMapReact from 'google-map-react';
import useApi from '../../api/useApi';
import '../../scrollbar.css';

function index({ gatewayData, handleClose }) {
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const [{ isLoading, isError, data }] = useApi();
  const [stats, setStats] = useState([]);
  const formModel = {
    q: '',
  };
  const [formData, setFormData] = useState(formModel);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const [gateways, getwaysData] = useApi();
  const [gateway, setGateways] = useState([]);
  let gatewayURL = '/zone/data?';
  const [openCreate, setOpenCreate] = useState(false);
  const day = 1000 * 60 * 60 * 24;

  useEffect(() => {
    for (let i = 0; i < gatewayData.gateways.length; i++) gatewayURL += `blegw[]=${gatewayData.gateways[i].deviceId}&`;
    user && getwaysData(gatewayURL, 'GET');
  }, [gatewayData]);

  useEffect(() => {
    if (gateways.isError) {
      setGateways([]);
    }
    if (!gateways.isLoading && !gateways.isError && gateways.data) {
      setGateways(gateways.data);
      setStats(gateways.data);
    }
  }, [gateways.isLoading, gateways.isError, gateways.data]);

  useEffect(() => {
    if (stats.length <= 0) {
      return;
    }

    let z = stats;
    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        const _data = x.data.filter((y, idx) => {
          if (y.assetName !== null) {
            return (
              y.deviceId.toLowerCase().indexOf(normalizedQuery) >= 0 ||
              y.assetName.toLowerCase().indexOf(normalizedQuery) >= 0
            );
          }
        });

        const obj = {
          blegwId: x.blegwId,
          data: _data,
        };
        const arr = [obj];
        setGateways(arr);
      });
    }
  }, [stats, formData]);

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  return (
    // <div className="h-full">
    <div className="flex justify-center items-center z-20">
      <div className="block lg:flex mt-1 lg:mt-0 absolute h-8 right-0 -top-10">
        <button
          className="mt-1 lg:mt-0 w-28 lg:w-max border px-3 py-1 rounded-2xl text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-8 bg-btnBg text-white rounded-md"
          onClick={handleClose}
        >
          Show Map
        </button>
        <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 py-1 rounded-2xl ml-3 flex justify-between items-center right-44 rounded-md">
          <input
            type="text"
            placeholder="Search Asset/Device"
            autoComplete="off"
            className="text-textBox text-xs bg-transparent focus:outline-none"
            value={formData.q}
            name="q"
            onChange={handleInputChange}
            style={{ borderColor: '#e6e6e6' }}
          />
          <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
        </div>
      </div>
      <div className="w-full">
        <div
          className="bg-white max-w-screen-xl mx-auto w-auto w-4 max-w-screen-xl mx-auto"
          style={{
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
            borderRadius: '6px',
          }}
        >
          <div className="w-4/5 ml-14 md:ml-0 md:w-full absolute bg-white" style={{ height: '83vh' }}>
            <p className="text-md font-bold py-3 w-11/12 m-auto">
              Last reported devices in zone {gatewayData.location}
            </p>
            <div className="bg-primary w-11/12 m-auto flex text-white">
              <div className="px-6 flex w-full py-3">
                <div className="text-left text-xs w-1/3">ASSET</div>
                <div className="text-left text-xs w-5/12">DEVICE</div>
                <div className="text-left text-xs w-3/4">GATEWAY</div>
                <div className="text-left text-xs w-1/2">SENSOR VALUES</div>
                <div className="text-left text-xs w-1/2">LAST REPORTED</div>
              </div>
            </div>
            {!gateways.isLoading ? (
              <div className="pb-1 hideScroll w-11/12 m-auto" style={{ overflow: 'auto' }}>
                {gateway
                  ? gateway.map((item) =>
                      item.data.map((itm, idx) => (
                        <div
                          className="my-1 px-6 flex py-2 text-role
                        relative"
                          style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                        >
                          <div className=" flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/3">
                            {itm?.assetName}
                          </div>
                          <div className=" flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-5/12">
                            {itm?.deviceId}
                          </div>
                          <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/4">
                            {item?.blegwId}
                          </div>
                          <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/2">
                            <img src="assets/img/temperature.png" className="w-2 mt-1 mr-2" alt="" />
                            {`${parseFloat(itm?.tm).toFixed(2)} ℃`}
                          </div>
                          <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/2">
                            {/* {itm.ts !== null
                                ? new Date(itm.ts).getDay() === 0
                                  ? `${new Date(itm.ts).getHours()} Hours Ago`
                                  : `${new Date(itm.ts).getDay()} Days Ago`
                                : 'N/A'} */}
                            {itm.ts !== null ? getTimeoffset(itm.ts) : 'N/A'}
                          </div>
                        </div>
                      ))
                    )
                  : null}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default index;
